import axios from 'axios'

export function finalizeSalesInvoice (SalesInvoiceId: number|string) {
  return axios.post('/sales-invoices/' + SalesInvoiceId + '/finalize')
}

export function getSalesInvoicePreviewAsPdf (SalesInvoiceId: number|string) {
  return axios.get('/sales-invoices/' + SalesInvoiceId + '/preview-pdf', {
    responseType: 'blob'
  })
}

export function getSalesInvoiceAsPdf (SalesInvoiceId: number|string) {
  return axios.get('/sales-invoices/' + SalesInvoiceId + '/pdf', {
    responseType: 'blob'
  })
}

export function creditSalesInvoice (SalesInvoiceId: number|string, shouldSendEmail: boolean = true) {
  const data = {
    should_send_email: shouldSendEmail
  }
  return axios.post('/sales-invoices/' + SalesInvoiceId + '/credit', data)
}